import './style.scss';
import {gsap} from 'gsap';
import {isRTL} from '../../scripts/isRTL';

export function mission_block() {
  const block = document.querySelector('.mission_block');
  if (!block) return;
  const text = block.querySelectorAll('.title, .description');
  const img = block.querySelector('.image');
  const imgWrapper = block.querySelector('.image-wrapper');
  const castle = block.querySelector('.left-svg');
  
  if (!(img && text)) return;
  // Main timeline for castle and text
  gsap.timeline({
    defaults: { duration: 1.5, ease: 'power2.out' },
    scrollTrigger: {
      trigger: block,
      toggleActions: 'play none none none',
      start: 'top center',
      end: 'bottom 20%',
    },
  })
      .addLabel('show-all')
      .from(castle, { x: 200, opacity: 0 })
      .from(text, { xPercent: -100, opacity: 0 }, 'show-all');

// Independent ScrollTrigger for the image
  gsap.from(img, {
    yPercent: 100,
    opacity: 0,
    duration: 1.2,
    ease: 'power4.out',
    scrollTrigger: {
      trigger: imgWrapper,
      start: 'top 60%',
      toggleActions: 'play none none none',
    },
  });
  
}
